module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_3_2.8185aa96.jpeg";